import React from 'react';
import {Link} from 'react-router-dom';
import {Email} from '@mui/icons-material';
import {darkBlue, themeColors} from '../../theme/Theme';
import {RenderColorBasic} from '../EditorGrid/GridRenderComponents';
import {gridCellDef} from '../../utils/GridCellDef';
import {ContactSearchFragment} from '../../schema-types/ContactSearchFragment';

export const RenderContactNameAndEmail: gridCellDef<ContactSearchFragment> = (params) => {
  const {
    row: {email},
  } = params;
  const importanceText = params.row.primary
    ? 'Primary'
    : params.row.secondary
    ? 'Secondary'
    : 'Dependant';
  return (
    <div
      style={{
        flex: 1,
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 4,
        paddingTop: 8,
        paddingBottom: 8,
        color: darkBlue,
        textDecoration: 'none',
        paddingLeft: 10,
        lineHeight: 1,
        height: '100%',
      }}
    >
      {RenderColorBasic(
        {
          Primary: themeColors.blue,
          Secondary: themeColors.yellow,
          Dependant: themeColors.lightPink,
        },
        importanceText,
        importanceText,
        undefined,
        undefined,
        undefined,
        true
      )}
      <Link
        className="sentry-mask"
        role="a"
        to={{pathname: `/contacts/${params.row.curoId}`}}
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{fontWeight: 600, color: darkBlue, textDecoration: 'none'}}
      >
        {params.row.simplifiedName}{' '}
      </Link>
      {params.row.isDeleted ? '(inactive)' : ''}
      {email ? (
        <a
          className="sentry-mask"
          onClick={(e) => e.stopPropagation()} // disable row navigation event
          style={{
            color: darkBlue,
            textAlign: 'center',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
          }}
          href={`mailto:${email}`}
        >
          <Email style={{marginRight: 4}} fontSize="small" />
          {email}
        </a>
      ) : null}
    </div>
  );
};
